import React from 'react'
import SocialLogin from 'react-social-login';
import {Button} from 'semantic-ui-react';

const ButtonSocial = ({ children, triggerLogin, triggerLogout, ...props }) => (
  	<Button onClick={triggerLogin} {...props} />   
)
 
export default SocialLogin(ButtonSocial)